import { META, PORTS } from './data';

// Avalon Footer — single-line marquee of ports + credits row, navy sea band
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#06151E] text-[#E8DDC7]">
      <div className="border-y border-[#E8DDC7]/10 overflow-hidden py-4">
        <div className="flex gap-12 animate-[scroll_55s_linear_infinite] whitespace-nowrap font-mono text-[11px] tracking-[0.4em] uppercase text-[#E8DDC7]/40">
          {[...PORTS, ...PORTS, ...PORTS].map((p, i) => (
            <span key={i} className="flex items-center gap-12">{p}<span className="text-[#B68F4E]">·</span></span>
          ))}
        </div>
      </div>
      <div className="max-w-[1440px] mx-auto px-8 lg:px-14 py-12 grid md:grid-cols-[1.4fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-3xl">{META.brand} <span className="text-[#B68F4E]">{META.tagline}</span></p>
          <p className="text-[#E8DDC7]/55 text-sm mt-3 max-w-md leading-[1.7]">A bureau for private yacht charter. Twelve hulls under our flag, sailed by captains we trust personally. Established {META.est}, {META.motto.split('.')[2]?.trim() || 'Antibes'}.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] mb-4">Bureau</p>
          <p className="text-[#E8DDC7]/65 text-sm leading-relaxed">Quai Antoine 1er<br />Antibes 06600, France</p>
          <p className="text-[#E8DDC7]/65 text-sm mt-3">+33 4 93 11 04 60</p>
          <p className="text-[#B68F4E] text-sm mt-1">bureau@avalonmaison.com</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] mb-4">Members of</p>
          <ul className="text-[#E8DDC7]/65 text-sm space-y-2">
            <li>MYBA — Worldwide Yachting Association</li>
            <li>UCINA — Italian Marine Industry</li>
            <li>FYBA — Florida Yacht Brokers</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E8DDC7]/10 px-8 lg:px-14 py-5 flex flex-wrap items-center justify-between gap-4 max-w-[1440px] mx-auto">
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E8DDC7]/30">© 2026 {META.brand} Maison · All charters MYBA-papered</p>
        <div className="flex gap-6 font-mono text-[10px] tracking-[0.3em] uppercase text-[#E8DDC7]/40">
          <button onClick={() => setPage('voyage')} className="hover:text-[#B68F4E]">Voyage Notes</button>
          <a href="#" className="hover:text-[#B68F4E]">Press</a>
          <a href="#" className="hover:text-[#B68F4E]">Privacy</a>
        </div>
      </div>
      <style>{`@keyframes scroll { from { transform: translateX(0); } to { transform: translateX(-33.33%); } }`}</style>
    </footer>
  );
}
